$(function() {

//==========================================================================
// STATE
//==========================================================================

//-----

/**
 * The components
 *
 * jQuery collection of section nodes that map to the component instances.
 *
 * @type       {jQuery}
 */
var $components;

//-----

/**
 * The window object wrapped in jQuery.
 *
 * @type       {jQuery}
 */
var $window;

//-----

//==========================================================================
// ENTRY POINT
//==========================================================================

init();

//==========================================================================
// INIT
//==========================================================================

//-----

/**
 * Get things rolling
 *
 * This is the function that will execute this module's logic. It's the
 * first and only statement in the module.
 */
function init() {

    // init rest of shared state
    initState();

    // if there are no components, we're done
    if (!$components.length) return;

    // otherwise, for each component, do stuff
    $components.each(manageComponent);
}

//-----

//==========================================================================
// FUNCTIONS
//==========================================================================

//===== NOT EVENTS =====================================================

//-----

/**
 * Init the rest of shared state
 *
 * Any state variable that common to all component instances, is not
 * the `$components` collection, and does not depend on loops like the
 * primary `manageComponent` one, will be initialized by this function.
 */
function initState() {

    // the window object
    $window = $(window);

    // get components on the page
    $components = $('section.banner-bancomer');
}

//-----

/**
 * Manage the logic for each component
 *
 * This is the primary controller function for a component. It orchestrates
 * the component's behaviour.
 *
 * @param      {number}  i          The component index in the `$components`
 *                                  collection. Unused.
 * @param      {<type>}  component  The component.
 */
function manageComponent(i , component) {

    var $component = $(component);
    var $topBox    = $component.find('.top-on-mobile');
    var $bottomBox = $component.find('.bottom-on-mobile');
    var handler;

    // init data scoped to the component
    initComponentData($component);

    // build handler for updating the top box height; we'll bind some
    // references to it's scope using partial aplication, and debounce
    // it's executtion a bit
    handler = __.debounce(__.partial(evtComponentH, __, $component, $topBox,
        $bottomBox), 80);

    // register the handler
    $window.on('resize.bannerBancomer heightChange', handler);

    // trigger resize
    $window.trigger('resize.bannerBancomer');
}

//-----

function initComponentData($component) {

    // init last-width
    $component.data('last-width', $window.width());

    // init flag for is first draw
    $component.data('is-first-draw', true);

    // init flag for picture height usage
    $component.data('use-picture-height', false);
}

//-----

function getDesktopHeight($component, $topBox, $bottomBox) {

    var desktopH    = $component.data('desktop-height');
    var usePictureH = $component.data('use-picture-height');
    var pictureH    = $topBox.find('picture').height();
    var bottomBoxH  = $bottomBox.height();
    var topBoxH;
    var tmp;

    // if the height has been overridden, use that
    if (desktopH) return desktopH;

    // else, if the picture height should be used, try to use it
    if (usePictureH) return Math.max(pictureH, bottomBoxH)

    // else, first get the topBoxH; in order for the resize not to show a
    // broken layout, restore the current height on the same event loop, so
    // that the debounced functions don't let the user see everything out of
    // place
    //
    // BROKEN: it is somehow leaking anyway, on resize and on other scenarios
    // the scroll is jumping. Let's try to set the component height during
    // the auto time
    tmp = $topBox.height();
    // try to avoid side effects due to setting height to auto in top-box
    $component.height($component.height());
    $topBox.height('auto');
    topBoxH = $topBox.height();
    $topBox.height(tmp);
    $component.height('auto');
    tmp = undefined;

    // then, add top and bottom box heights
    return topBoxH + bottomBoxH;
}

//-----

function hidePicture($component, $topBox, currWidth) {

    var currWidth = $window.width();
    var $picture = $component.find('picture');
    var $content = $component.find('.row.title-block', '.row.iframe');
    var pictureH = $picture.height(); // 0 if hidden

    // we use the hide class instead of $.show() because there are other
    // CSS rules and situations that may hide the picture
    if (currWidth < media.desktop) {
        $picture.removeClass('hide');
        return;
    }

    // there's either iframe or text-block visible on the top side,
    // hide the picture
    if (pictureH && $content.length) {
        $picture.addClass('hide');
        return;
    }

    // when there's no content visible on the top side, picture's height is
    // not 0; in this scenario, we flag the use of the picture height for
    // the height of the top box
    if (pictureH && !$content.length) {
        $component.data('use-picture-height', true);
    }
}

//-----

//===== EVENTS =========================================================

//-----

function evtComponentH(event, $component, $topBox, $bottomBox) {

    var currWidth      = $window.width();
    var lastWidth      = $component.data('last-width');
    var wasDesktop     = lastWidth >= media.desktop;
    var isDesktop      = currWidth >= media.desktop;
    var isFirstDraw    = $component.data('is-first-draw');
    var isHeightChange = event.type === 'heightChange';

    // we can now set first draw to false
    $component.data('is-first-draw', false);

    // remove js-hide class
    if ($component.hasClass('js-hide')) $component.removeClass('js-hide');

    // if needed, hide picture
    hidePicture($component, $topBox, currWidth);

    // let the top box height adjust to it's content
    if (!isDesktop) {
        $topBox.height('auto');
    }

    // if the height must be as in desktop
    else if (isFirstDraw || isHeightChange || !wasDesktop) {
        $topBox.height(getDesktopHeight($component, $topBox, $bottomBox));
    }

    // on iframe height change, we may need to reset topBox height
    // they will fire 'iframe-height-change' with an iframe reference
    $window.on('iframe-height-change', function(event, iframe) {
        // return if not our iframe
        if ($component.find('iframe')[0] !== iframe) return;

        // get the iframe height
        var $iframe = $(iframe);
        var currHeight = $iframe.height();

        // init persistent iframe height storage
        if (__.isUndefined($topBox.data('iframeH-last'))) {
            $topBox.data('iframeH-last', -1);
        }

        // get iframe last height
        var lastHeight = $topBox.data('iframeH-last');

        // if curr height didn't change, we're done
        if (currHeight === lastHeight) return;

        // otherwise, recalc $topBox height and store new last height
        $topBox.height(getDesktopHeight($component, $topBox, $bottomBox));
        $topBox.data('iframeH-last', currHeight);
    });

    // update last-width
    $component.data('last-width', currWidth);
}

//-----

});
